
const initialState = {
    SiteId: null,
    NomSite: null,
};

const siteinformation = (state = initialState, action = { type: null }) => {

    if (action.type === "InformationChange") {
        return {
            ...state,
            SiteId: action.SiteId,
            NomSite: action.NomSite,
        }
    } else {
        return state
    }

}

export default siteinformation;